import React, { FC, PropsWithChildren, createContext, useContext, useEffect, useState } from 'react'
import { Application, ApplicationProfile } from '../models/User'
import { useParams } from 'react-router-dom'
import UserService from '../services/UserService'
import ProfileService from '../services/Profile.service'
import { useAuth } from '../contexts/AuthContext'

interface ApplicationsContextType {
  applications: Application[]
  profileApps: ApplicationProfile[]
  setApplications: any
  setProfileApps: any
}

const initialContext: ApplicationsContextType = {
  applications: [],
  profileApps: [],
  setApplications: () => undefined,
  setProfileApps: () => undefined,
}

export const ApplicationsContext = createContext<ApplicationsContextType>(initialContext)

export const useApplications = () => useContext(ApplicationsContext)

const ApplicationsContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const { userId } = useAuth()
  const [applications, setApplications] = useState<Application[]>([])
  const [profileApps, setProfileApps] = useState<ApplicationProfile[]>([])
  const { org } = useParams()

  useEffect(() => {
    if (!org) return
    UserService.listApplications(org).then(setApplications)
    userId && ProfileService.getApplications(org, userId!).then((data) => setProfileApps(data?.applications))
  }, [org, userId])

  return (
    <ApplicationsContext.Provider value={{ applications, profileApps, setApplications, setProfileApps }}>
      {children}
    </ApplicationsContext.Provider>
  )
}

export default ApplicationsContextProvider
